import React from 'react';
import { ArrowUpRight, CalendarDays, MapPin, Sparkles } from 'lucide-react';
import { formatEventWhen } from '../lib/time';

export default function EventCard({ event }) {
  const destination = event.deal_url || event.website_url;
  const where = [event.neighbourhood, event.city].filter(Boolean).join(', ');
  return <article style={styles.card}>
    {event.image_url && <img src={event.image_url} alt={event.title} style={styles.cardImage} />}
    <div style={styles.cardTop}><span style={styles.type}>{event.event_type || 'Event'}</span>{event.featured && <span style={styles.featured}><Sparkles size={13} /> Featured</span>}</div>
    {event.starts_at && <p style={styles.when}><CalendarDays size={15} /> {formatEventWhen(event.starts_at, event.expires_at)}</p>}
    <h3 style={styles.cardTitle}>{event.title}</h3>
    <p style={styles.organizer}>{event.merchant}</p>
    <p style={styles.description}>{event.description}</p>
    <div style={styles.cardFooter}>
      <span style={styles.where}>{where && <><MapPin size={14} style={{ flexShrink: 0 }} /> {where}</>}</span>
      {destination && <a href={destination} target="_blank" rel="noopener noreferrer" style={styles.cta}>Details <ArrowUpRight size={16} /></a>}
    </div>
    {event.terms && <p style={styles.terms}>{event.terms}</p>}
  </article>;
}

const styles = {
  card: { background: '#fff', border: '1px solid #d8d8d8', borderRadius: 14, padding: '1.25rem', minHeight: 260, display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  cardImage: { width: 'calc(100% + 2.5rem)', height: 176, objectFit: 'contain', background: '#f5f5f5', margin: '-1.25rem -1.25rem 1rem', borderBottom: '1px solid #ddd' },
  cardTop: { display: 'flex', justifyContent: 'space-between', gap: 8 },
  type: { color: '#111', background: '#eee', borderRadius: 999, fontSize: '0.72rem', fontWeight: 700, padding: '0.35rem 0.55rem' },
  featured: { color: '#111', display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: '0.75rem', fontWeight: 700 },
  when: { display: 'flex', alignItems: 'center', gap: 6, color: '#111', fontWeight: 700, fontSize: '0.9rem', margin: '1.2rem 0 0.5rem' },
  cardTitle: { fontSize: '1.45rem', lineHeight: 1.08, letterSpacing: '-0.035em', margin: 0 },
  organizer: { color: '#555', fontWeight: 600, fontSize: '0.88rem', margin: '0.45rem 0 0' },
  description: { color: '#333', lineHeight: 1.5, margin: '0.8rem 0 1rem' },
  cardFooter: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginTop: 'auto', paddingTop: '1rem', color: '#444', fontSize: '0.8rem' },
  where: { display: 'inline-flex', alignItems: 'center', gap: 5, minWidth: 0 },
  cta: { color: '#fff', background: '#111', textDecoration: 'none', fontWeight: 800, borderRadius: 7, padding: '0.55rem 0.65rem', display: 'inline-flex', alignItems: 'center', gap: 3, whiteSpace: 'nowrap', flexShrink: 0 },
  terms: { color: '#666', fontSize: '0.71rem', lineHeight: 1.4, margin: '0.8rem 0 0' },
};
